import { render } from "./AposColorSaturation.vue?vue&type=template&id=18eacfda"
import script from "./AposColorSaturation.vue?vue&type=script&lang=js"
export * from "./AposColorSaturation.vue?vue&type=script&lang=js"

import "./AposColorSaturation.vue?vue&type=style&index=0&id=18eacfda&lang=css"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"color-field/ui/apos/lib/AposColorSaturation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18eacfda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18eacfda', __exports__)) {
    api.reload('18eacfda', __exports__)
  }
  
  module.hot.accept("./AposColorSaturation.vue?vue&type=template&id=18eacfda", () => {
    api.rerender('18eacfda', render)
  })

}


export default __exports__